import React from "react";
import cx from 'classnames';
import Styles from './index.module.scss';

interface IProcessBar {
  className?: string;
}

const ProcessBar = ({
  className,
}: IProcessBar) => {
  return (
    <div className={cx(Styles.root, className)}>
      <div className={Styles.processBar}></div>
    </div>
  )
}

export default ProcessBar;